import React from "react";
import SortingVisualizer from "./SortingVisualizer";

function App() {
  return (
    <div className="App">
      <SortingVisualizer />
    </div>
  );
}

export default App;
